(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["biomat-eligibility-codes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('biomat-eligibility-codes')) {
    customElements.define('biomat-eligibility-codes', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-biomat-code]');
          if (!button || !this.contains(button)) return;
          const status = this.querySelector('[role="status"]');
          const code = button.dataset.biomatCode;
          try {
            await navigator.clipboard.writeText(code);
            status.textContent = code + ': ' + status.dataset.copied;
            clearTimeout(this.copyFlashTimer);
            this.querySelectorAll('.is-copied').forEach((item) => item.classList.remove('is-copied'));
            void button.offsetWidth;
            button.classList.add('is-copied');
            this.copyFlashTimer = setTimeout(() => {
              button.classList.remove('is-copied');
              const details = this.querySelector('details');
              if (details.open) {
                if (this.contains(document.activeElement)) details.querySelector('summary').focus({ preventScroll: true });
                details.open = false;
              }
            }, 650);
          } catch {
            status.textContent = status.dataset.copyFailed + ' ' + code;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
